import { useEffect } from 'react';
import { setUnsavedChangesGuard } from '../utils/unsavedChangesGuard';

/**
 * While `message` is set, switching app tabs asks for confirmation with it,
 * and closing or reloading the browser tab shows the browser's own warning.
 * `key` must be unique per screen or item.
 */
export function useUnsavedChanges(key: string, message: string | null): void {
  useEffect(() => {
    if (!message) return;
    setUnsavedChangesGuard(() => message, key);
    const onBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      setUnsavedChangesGuard(null, key);
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [key, message]);
}
